import React from 'react';
import Icon, { IconProps } from '../Icon';

const IconEditPenCircle: React.FC<IconProps> = ({ ...props }) => {
  const fill = props.fill;
  return (
    <Icon {...props}>
      <circle cx="12" cy="12" r="12" fill={fill} />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M6 15.5V18H8.5L15.8665 10.6335L13.3665 8.13354L6 15.5ZM17.8001 8.69995C18.0667 8.43335 18.0667 8.03326 17.8001 7.76666L16.2333 6.19995C15.9667 5.93335 15.5667 5.93335 15.3001 6.19995L14.0667 7.43335L16.5667 9.93329L17.8001 8.69995V8.69995Z"
        fill="white"
      />
    </Icon>
  );
};

export default IconEditPenCircle;
